import React from "react";
import style from "./index.module.scss";
import { Button, Icon } from "antd";

interface ConfirmProps {
    onCancel: () => void;
    onOk: () => void;
}

export default function Confirm({ onCancel, onOk }: ConfirmProps) {
    return (
        <div className={style.root}>
            <div className={style.wrapper}>
                <Icon type="question-circle" />
                &nbsp;&nbsp; 存在未保存的数据，是否保存？
                <Button type="primary" onClick={onOk}>
                    保存
                </Button>
                <Button type="primary" ghost onClick={onCancel}>
                    不保存
                </Button>
            </div>
        </div>
    );
}
